import pulse from '@finn-no/pulse-sdk';

// TJT_ev13
const trackFeedView = () =>
    pulse.trackEvent({
        type: 'View',
        intent: 'Open',
        name: 'TJT active ad',
        object: {
            id: `tjt-transaction-feed`,
            type: 'UIElement',
            elementType: 'Button',
            position: 'Frontpage',
        },
        vertical: {
            name: 'common_pages',
        },
    });

// TJT_ev11
const trackAdClick = (adId: number | undefined, status: string) => {
    if (!adId) {
        // Currently, adId is not a mandatory prop from the endpoint.
        // Which is not a problem right now because it will always be present for sellers.
        // But if we one day will list out buyers transactions, we need some changes in the api as well.
        // So just keeping this here as a reminder if that happens.
        console.error('Finnkode is missing.');
        return;
    }

    const finnkode = adId.toString();

    pulse.trackEvent({
        type: 'Click',
        intent: 'Open',
        name: 'Go to TJT ad',
        object: {
            id: `tjt-transaction-feed-item`,
            type: 'UIElement',
            elementType: 'Button',
            position: 'Frontpage',
            items: [
                {
                    type: 'ClassifiedAd',
                    id: finnkode,
                    contentId: finnkode,
                    name: 'n/a',
                    category: 'n/a',
                },
                {
                    type: 'ProcessFlow',
                    id: finnkode,
                    name: 'Torget transaction',
                    taskName: status,
                    isAdvertiser: true,
                },
            ],
        },
        target: {
            type: 'ClassifiedAd',
            id: finnkode,
            name: 'go to my ad',
            category: 'n/a',
        },
        vertical: {
            name: 'common_pages',
        },
    });
};

const pulseClient = {
    trackFeedView,
    trackAdClick,
};

export default pulseClient;
